var _style, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 832.01 425.87",
    style: {
      enableBackground: "new 0 0 832.01 425.87"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#E4E2DD;}\n\t.st1{fill:#21273D;}\n\t.st2{fill:#EF9A1E;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M213.86,193.54c-9.78,9.65-22.42,14.13-36.14,14.13c-35.33,0-50.28-24.32-50.41-49.05    c-0.14-24.87,16.03-50.14,50.41-50.14c12.91,0,25.14,4.89,34.92,14.54l-11.96,11.55c-6.25-6.12-14.68-8.97-22.96-8.97    c-22.96,0-32.88,17.12-32.75,33.02c0.13,15.76,9.24,32.21,32.75,32.21c8.29,0,17.67-3.4,23.92-9.65L213.86,193.54z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M345.94,158.49c-0.27,24.59-15.35,49.19-48.78,49.19c-33.43,0-48.92-24.05-48.92-49.05    c0-25,16.04-50.14,48.92-50.14C329.91,108.48,346.21,133.62,345.94,158.49z M265.91,158.89c0.41,15.63,8.83,32.34,31.25,32.34    c22.42,0,30.85-16.85,31.12-32.48c0.27-16.03-8.7-33.97-31.12-33.97C274.74,124.79,265.5,142.86,265.91,158.89z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M464.98,137.97c0,7.34-3.53,14.4-12.36,18.34c11.14,3.4,15.22,15.22,15.22,21.2c0,21.2-15.9,27.99-35.6,27.99    c-15.08,0-30.03,0-45.11,0v-95.12c14.95,0,30.03,0,45.11,0C450.99,110.38,464.98,118.81,464.98,137.97z M404.79,148.57h27.45    c11.28,0,14.94-4.76,14.94-10.19c0-4.35-3.53-11.69-14.94-11.69h-27.45V148.57z M404.79,188.79h27.45c7.34,0,17.8-2.45,17.8-11.41    c0-8.56-10.46-13.04-17.8-13.04h-27.45V188.79z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M579.94,205.5h-71.2c0-31.66,0-63.46,0-95.12h71.2v17.39h-53.4v21.88h51.5v16.71h-51.5v21.47h53.4V205.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M687.71,110.25h17.94v95.26H694.5v0.13l-50-64.27v64.14h-17.94v-95.12h14.54l46.61,58.97V110.25z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M162.18,315.09v-17.31h-21.04v17.31h-8.07v-42.82h8.07v18.05h21.04v-18.05h8.01v42.82H162.18z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M228.04,315.02h-32.05c0-14.25,0-28.56,0-42.82h32.05v7.83H204v9.85h23.18v7.52H204v9.67h24.04V315.02z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M283.02,306.95h-22.39l-3.67,8.08h-8.75l19.21-42.82h8.81l19.21,42.82h-8.81L283.02,306.95z M271.82,281.2    l-7.95,18.23h15.9L271.82,281.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M326.12,272.21v35.35h22.02v7.46h-30.1v-42.82H326.12z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M376.88,279.55H363.3v-7.34c12.36,0,22.82,0,35.23,0v7.34h-13.58v35.48h-8.08V279.55z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M450.93,315.09v-17.31h-21.04v17.31h-8.07v-42.82h8.07v18.05h21.04v-18.05h8.01v42.82H450.93z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M522.6,309.64c-4.4,4.34-10.09,6.36-16.27,6.36c-15.9,0-22.63-10.95-22.69-22.08    c-0.06-11.19,7.22-22.57,22.69-22.57c5.81,0,11.32,2.2,15.72,6.55l-5.38,5.2c-2.81-2.75-6.6-4.04-10.34-4.04    c-10.34,0-14.8,7.71-14.74,14.87c0.06,7.1,4.16,14.5,14.74,14.5c3.73,0,7.95-1.53,10.77-4.34L522.6,309.64z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M573.97,306.95h-22.39l-3.67,8.08h-8.75l19.21-42.82h8.81l19.21,42.82h-8.81L573.97,306.95z M562.77,281.2    l-7.95,18.23h15.9L562.77,281.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M646.31,315.02h-9.6l-12.48-14.31h-7.77v14.31h-8.07v-42.88c6.79,0,13.58,0.06,20.37,0.06    c10.09,0.06,15.42,6.79,15.42,14.19c0,5.87-2.69,11.81-10.83,13.46l12.97,14.62V315.02z M616.46,279.73v13.7h12.3    c5.14,0,7.34-3.42,7.34-6.85c0-3.43-2.26-6.85-7.34-6.85H616.46z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M699.88,315.02h-32.05c0-14.25,0-28.56,0-42.82h32.05v7.83h-24.04v9.85h23.18v7.52h-23.18v9.67h24.04V315.02z    "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 127.77,
    y: 235.29,
    className: "st1",
    width: 577.41,
    height: 6.64
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.e0de0adf4474264fcf971062a633c600.svg";
export { ForwardRef as ReactComponent };